"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonsFactory = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _variables = require("../../styles/variables");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ButtonsFactory = _styledComponents["default"].div.withConfig({
  componentId: "appname-__sc-gvxydp-0"
})(["display:flex;align-items:center;width:100%;justify-content:", ";flex-direction:", ";@media (min-width:", "){flex-direction:row;}> *{width:", ";", ";", ";@media (min-width:", "){width:initial;margin:0 16px 0 0;&:last-child{margin-right:0;}}}"], function (_ref) {
  var justifyContent = _ref.justifyContent;
  return justifyContent;
}, function (_ref2) {
  var disableBreakpoints = _ref2.disableBreakpoints,
    reverseOnMobile = _ref2.reverseOnMobile;
  var reversed = reverseOnMobile ? 'column-reverse' : 'column';
  return disableBreakpoints ? 'row' : reversed;
}, _variables.breakpoints.medium, function (_ref3) {
  var disableBreakpoints = _ref3.disableBreakpoints;
  return disableBreakpoints ? 'initial' : '100%';
}, function (_ref4) {
  var disableBreakpoints = _ref4.disableBreakpoints;
  return disableBreakpoints ? 'margin-right: 16px' : 'margin-bottom: 16px';
}, function (_ref5) {
  var reverseOnMobile = _ref5.reverseOnMobile;
  return reverseOnMobile ? "\n                &:first-child {\n                    margin-bottom: 0;\n                }\n            " : "\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            ";
}, _variables.breakpoints.medium);
exports.ButtonsFactory = ButtonsFactory;